export const demoShifts = [
  {
    source_title: "The Lean Startup by Eric Ries",
    source_link: "https://example.com",
    source_type: "Book",
    before_belief: "Success requires perfect planning and detailed execution from day one",
    after_belief: "Success comes from rapid experimentation, learning from failures, and iterating quickly",
    reflection: "This book completely changed how I think about building products. The Build-Measure-Learn feedback loop made me realize that my fear of launching imperfect products was actually holding me back. Now I understand that validated learning is more valuable than a perfect plan.",
    location_name: "San Francisco, CA",
    lat: 37.7749,
    lng: -122.4194,
    is_public: true
  },
  {
    source_title: "Thinking, Fast and Slow by Daniel Kahneman",
    source_link: "https://example.com",
    source_type: "Book",
    before_belief: "People make rational decisions based on logic and data",
    after_belief: "Most decisions are driven by fast, intuitive thinking prone to systematic biases",
    reflection: "Learning about System 1 and System 2 thinking was eye-opening. I now recognize cognitive biases in my own decision-making and try to slow down for important choices. The anchoring effect and availability heuristic are everywhere once you know what to look for.",
    location_name: "New York, NY",
    lat: 40.7128,
    lng: -74.0060,
    is_public: true
  },
  {
    source_title: "Deep Work by Cal Newport",
    source_link: "https://example.com",
    source_type: "Book",
    before_belief: "Multitasking and staying connected makes me more productive",
    after_belief: "Deep, focused work without distractions produces the highest quality output",
    reflection: "I used to think constant communication was essential. This book taught me that deep concentration is becoming rare and therefore more valuable. I now schedule 3-hour blocks of uninterrupted work and my productivity has doubled.",
    location_name: "Austin, TX",
    lat: 30.2672,
    lng: -97.7431,
    is_public: true
  },
  {
    source_title: "Atomic Habits by James Clear",
    source_link: "https://example.com",
    source_type: "Book",
    before_belief: "Big changes require massive willpower and motivation",
    after_belief: "Small, consistent habits compound into remarkable results over time",
    reflection: "The 1% improvement philosophy changed everything. Instead of trying to overhaul my life overnight, I focused on tiny improvements. The concept of identity-based habits—becoming the type of person who does X—was particularly powerful.",
    location_name: "Seattle, WA",
    lat: 47.6062,
    lng: -122.3321,
    is_public: true
  },
  {
    source_title: "The Mom Test by Rob Fitzpatrick",
    source_link: "https://example.com",
    source_type: "Book",
    before_belief: "I should pitch my idea and ask people if they like it",
    after_belief: "I should ask about their problems and past behavior, not hypothetical futures",
    reflection: "This short book revolutionized how I do customer research. I learned that everyone will lie to you—not maliciously, but because they want to be nice. Asking about specific past actions instead of future intentions gives real signal.",
    location_name: "Boston, MA",
    lat: 42.3601,
    lng: -71.0589,
    is_public: true
  },
  {
    source_title: "Designing Your Life by Bill Burnett",
    source_link: "https://example.com",
    source_type: "Book",
    before_belief: "There's one right path I need to discover",
    after_belief: "Life is a design problem with multiple good solutions worth prototyping",
    reflection: "The idea of prototyping your life like a product designer was liberating. Instead of agonizing over the 'perfect' career choice, I started running small experiments. Odyssey plans showed me three different futures are all viable.",
    location_name: "Portland, OR",
    lat: 45.5152,
    lng: -122.6784,
    is_public: true
  }
];

// Initialize demo data on first load
export function initializeDemoData() {
  if (localStorage.getItem('shifts') === null) {
    const shiftsWithIds = demoShifts.map((shift, index) => ({
      ...shift,
      id: `demo-${index}`,
      created_at: new Date(Date.now() - (6 - index) * 24 * 60 * 60 * 1000).toISOString()
    }));
    localStorage.setItem('shifts', JSON.stringify(shiftsWithIds));
  }

  if (localStorage.getItem('trails') === null) {
    localStorage.setItem('trails', JSON.stringify([]));
  }

  if (localStorage.getItem('savedShifts') === null) {
    localStorage.setItem('savedShifts', JSON.stringify([]));
  }
}
